import React, {useState, useEffect, useContext, useRef} from 'react'
import UserContext from '../../context/context'
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { history } from '../../_helpers';

import {DefaultColumnFilter, multiSelectFilter, SelectColumnFilter} from './Table_ra'
import {TableApp} from './Table_ra'
import '../Nav/Nav.scss'
// import ComRaboardDetail from './ComRaboardDetail';
import "./ComRaboard.scss"
import Select from 'react-select';

import { useHistory } from 'react-router'




const columnsAtt = [
  //   {Header: 'Parent ID', accessor: 'parentUUID', Filter: DefaultColumnFilter,    filter: 'fuzzyText',},

  {id:'email', Header: 'Email',   accessor: 'email',   Filter: DefaultColumnFilter,    filter: 'fuzzyText',},
  {id:'id', Header: 'ID',   accessor: 'id'},
  {id:'name', Header: 'Name',   accessor: 'name',   Filter: DefaultColumnFilter,    filter: 'fuzzyText',},
  {id:'position', Header: 'Position',      accessor: 'position', filter: 'includes',},
  {id:'path', Header: 'Path',      accessor: 'path', filter: 'includes', Filter: SelectColumnFilter},
  
  {id:'status', Header: 'Status',      accessor: 'status', filter: multiSelectFilter, Filter: SelectColumnFilter},
  {id:'action', Header: 'Action',      accessor: 'action', filter: 'includes', Filter: SelectColumnFilter},
  {id:'updated', Header: 'Last',      accessor: 'updated', Filter: SelectColumnFilter,     filter: 'includes',},
  {id:'DB', Header: 'DB',      accessor: 'which', Filter: SelectColumnFilter,  filter: 'includes',},
  {id:'profile', Header: 'Profile',      accessor: 'profile'},


]



function ComRaboardDetail(props){

  const history_router = useHistory()

  const [state, actions] = useContext(UserContext);
  const [single, setSingle] = useState() 
  const [applicants, setApplicants] = useState()
  
  
  const [changed, setChanged] = useState(false)
  const [status, setStatus] = useState([])

  const [schoolwork, setSchoolwork] = useState()


  let user = JSON.parse(String(localStorage.getItem('user')))
  let email = String(localStorage.getItem('email'))

  const header = {Authorization: `JWT ${user.token}`}

  // // console.log(history.location.pathname.split('/')[2])
  
  let current_id = history.location.pathname.split('/')[3]
  let current_status = history.location.pathname.split('/')[4]
  // let current_id = props.id

  
  let single_ra

  let apilink
  if(current_status === "ra") apilink = "/api/ra/?id="
  else apilink = "/api/rahh/?id="

  const [currentId, setCurrentId] = useState(history.location.pathname.split('/')[3])

  
  
  function fetchApplyStatus(id, status, step, candidate, which){
    if(window.confirm(candidate + step + "?")){
      fetch(state.awslink + "/api/applyStatus/", {
        method: 'POST',
        headers: header,
        body:JSON.stringify({
          "id": id,
          "status": status || "7%",
          "step": step,
          "candidate": candidate,
          "which": which,
        })
      })
      .then(response => response.json())
      .then(json=>{
        // console.log(json)
        setApplicants(null)
        fetchSingleRa(id)
        setChanged(!changed)
      })
    }
  }

  function fetchReCart(id, status, step, candidate, which){
    console.log(candidate)
    if(window.confirm(candidate + step + "?")){
      fetch(state.awslink + "/api/recartshop/", {
        method: 'POST',
        headers: header,
        body:JSON.stringify({
          "id": id,
          "status": status,
          "step": step,
          "candidate": candidate,
          "which": which,
        })
      })
      .then(response => response.json())
      .then(json=>{
        // console.log(json)
        setApplicants(null)
        fetchSingleRa(id)
        setChanged(!changed)
      })
    }
  }

  function fetchSingleRa(id){
    fetch(state.awslink + apilink + id, {
    method: 'GET',
    headers: header,
    })
    .then(response => response.json())
    .then(json=>{
      // console.log(json)
      actions.setSingleRa(json)
    })
  }

  function getDataFromList(info, actiondiv, subitem, single_ra, json, which){
    let newobj = subitem;
    console.log("138", newobj.name)

    if(info["school"].length){
      if(info["school"].filter(item=>item["user"] === subitem.id).length){
        
        if(info["school"].filter(item=>item["user"] === subitem.id)[0]["username"].length===1)
          newobj.name = info["school"].filter(item=>item["user"] === subitem.id)[0]["username"] + " OO" || null
        else
          newobj.name = info["school"].filter(item=>item["user"] === subitem.id)[0]["username"]|| null
        
        newobj.school = info["school"].filter(item=>item["user"] === subitem.id)[0]["title"] || null
        newobj.degree = info["school"].filter(item=>item["user"] === subitem.id)[0]["degree"] || null
        newobj.profile = info["school"].filter(item=>item["user"] === subitem.id)[0]["profilelink"] || null
      }
      else{
        // newobj.name = "없음"
        // newobj.school = "없음"
        // newobj.degree = "없음"
      }
    }

    if(info["work"].length){
      if(info["work"].filter(item=>item["user"] === subitem.id).length){
        newobj.work = info["work"].filter(item=>item["user"] === subitem.id)[0]["title"] || null
      }
    }
    else{
      // newobj.work = "없음"
    }

    
    
    console.log(subitem.email)
    // newobj.email = subitem.email
    console.log(newobj)
    console.log(newobj.position, single_ra.job)
    if(newobj !== undefined)
      newobj.position = single_ra.job

    // // console.log(json)
    // // console.log(subitem)

    // console.log(json.filter((item)=>item.user.email === subitem.email))
  
    // info = user info
    // subitem = ra 안에 applicants [] 
    // json = applicants, apply 정보
    if(json.filter((item)=> item.userSecond ? item.userSecond.id === subitem.id: item.user.id === subitem.id).length){
      newobj.path = json.filter((item)=> item.userSecond ? item.userSecond.id === subitem.id: item.user.id === subitem.id)[0].recart || "후보자지원"

      newobj.status = json.filter((item)=> item.userSecond ? item.userSecond.id === subitem.id: item.user.id === subitem.id)[0].step
      newobj.updated = json.length ? json.filter((item)=> item.userSecond ? item.userSecond.id === subitem.id: item.user.id === subitem.id)[0].updated.split('T')[0]: null
    }
    else{
      newobj.path = null
      newobj.status=null
      newobj.updated=null
    }
    

    newobj.action = actiondiv

    // newobj.updated = json.length ? json.filter((item)=> item.user ? item.user.email === subitem.email: item.userSecond.email === subitem.email)[0].updated.split('T')[0]: null

    newobj.which = which

    // console.log(newobj)
    
    return newobj

  }
  
  async function fetchSingleApplicants(info){
    // console.log("GETTING DATA")
    const res = fetch(state.awslink + "/api/applicants/?id=" + current_id + 
    '&status=' + current_status , {
      method: 'GET',
      headers: header,
      })
      .then(response => response.json())
      .then(json=>{
        console.log(json)
        
        
        if(state.ra){

          single_ra = state.singleRa
          if(single_ra){
            let app_data = [];
            if(single_ra.applicant !== undefined){
              app_data = single_ra.applicant.map((subitem, index)=>{
                return(
                  getDataFromList(info, <div>
                    <button style={{color: "black"}}onClick={()=>fetchApplyStatus( single_ra.id, single_ra.status, "서류합격", subitem.id, "DB1" )}>서류합격</button>
                    <button style={{color: "black"}}onClick={()=>fetchApplyStatus( single_ra.id, single_ra.status, "불합격", subitem.id, "DB1" )}>불합격</button>
                  </div>, subitem, single_ra, json, "DB1")
                )
              })
            }

            let recommended_data = []
            if(single_ra.recommended !== undefined){
              recommended_data = single_ra.recommended.map((subitem)=>{
                return(
                  getDataFromList(info, user.user["pk"] === single_ra.user?
                  <div>
                    <button style={{color: "black"}}onClick={()=>fetchApplyStatus( single_ra.id, single_ra.status, "서류합격", subitem.id, "DB1" )}>서류합격</button>
                    <button style={{color: "black"}}onClick={()=>fetchApplyStatus( single_ra.id, single_ra.status, "불합격", subitem.id, "DB1" )}>불합격</button>
                  </div>: null
                  , subitem, single_ra, json, "DB1")
                )
              })
            }
            
            let recommended_sent_data = []
            if(single_ra.recommended_sent !== undefined){
              recommended_sent_data = single_ra.recommended_sent.map((subitem)=>{
                return(
                  getDataFromList(info, 
                    // email === single_ra.user["email"]?
                    //   <div>
                    //     <button style={{color: "black"}}onClick={()=>fetchApplyStatus( single_ra.id, single_ra.status, "서류합격", subitem.email, "DB1" )}>서류합격</button>
                    //     <button style={{color: "black"}}onClick={()=>fetchApplyStatus( single_ra.id, single_ra.status, "불합격", subitem.email, "DB1" )}>불합격</button>
                    //   </div>: null
                    "답변대기중"
                  , subitem, single_ra, json, "DB1")
                )
              })
            }

            let recommended_accepted_data = []
            if(single_ra.recommended_accepted !== undefined){
              recommended_accepted_data = single_ra.recommended_accepted.map((subitem)=>{
                return(
                  getDataFromList(info, 
                    // email === single_ra.user["email"]?
                      <div>
                        <button style={{color: "black"}}onClick={()=>fetchReCart( single_ra.id, single_ra.status, "추천", subitem.id, "DB1" )}>추천하기</button>
                        <button style={{color: "black"}}onClick={()=>fetchApplyStatus( single_ra.id, single_ra.status, "불합격", subitem.id, "DB1" )}>불합격</button>
                      </div>
                      // : null
                    // "답변대기중"
                  , subitem, single_ra, json, "DB1")
                )
              })
            }


            let recommended_second_data = []
            if(single_ra.recommended_second !== undefined){
              recommended_second_data = single_ra.recommended_second.map((subitem)=>{
                return(
                  getDataFromList(info, user.user["pk"] === single_ra.user?
                  <div>
                    <button style={{color: "black"}}onClick={()=>fetchApplyStatus( single_ra.id, single_ra.status, "서류합격", subitem.id, "DB2" )}>서류합격</button>
                    <button style={{color: "black"}}onClick={()=>fetchApplyStatus( single_ra.id, single_ra.status, "불합격", subitem.id, "DB2" )}>불합격</button>
                  </div>: null
                  , subitem, single_ra, json, "DB2")
                )
              })
            }

            let recommended_sent_second_data = []
            if(single_ra.recommended_sent_second !== undefined){
              recommended_sent_second_data = single_ra.recommended_sent_second.map((subitem)=>{
                return(
                  getDataFromList(info, 
                    // email === single_ra.user["email"]?
                    //   <div>
                    //     <button style={{color: "black"}}onClick={()=>fetchApplyStatus( single_ra.id, single_ra.status, "서류합격", subitem.email, "DB1" )}>서류합격</button>
                    //     <button style={{color: "black"}}onClick={()=>fetchApplyStatus( single_ra.id, single_ra.status, "불합격", subitem.email, "DB1" )}>불합격</button>
                    //   </div>: null
                    "답변대기중"
                  , subitem, single_ra, json, "DB2")
                )
              })
            }
            
            let recommended_accepted_second_data = []
            if(single_ra.recommended_accepted_second !== undefined){
              recommended_accepted_second_data = single_ra.recommended_accepted_second.map((subitem)=>{
                return(
                  getDataFromList(info, 
                    // email === single_ra.user["email"]?
                      <div>
                        <button style={{color: "black"}}onClick={()=>fetchReCart( single_ra.id, single_ra.status, "추천", subitem.id, "DB1" )}>추천하기</button>
                        <button style={{color: "black"}}onClick={()=>fetchApplyStatus( single_ra.id, single_ra.status, "불합격", subitem.id, "DB1" )}>불합격</button>
                      </div>
                      // : null
                    // "답변대기중"
                  , subitem, single_ra, json, "DB2")
                )
              })
            }

            let cart_data = [];
            if(single_ra.cart !== undefined){
              cart_data = single_ra.cart.map((subitem)=>{
                return(
                  getDataFromList(info, 
                    // email === single_ra.user["email"]?
                  <div>
                    {user.user["pk"] === single_ra.user && 
                      <button style={{color: "black"}} onClick={()=>fetchReCart( single_ra.id, single_ra.status, "제안보냄", subitem.id, "DB1" )}>지원제안</button>}
                    
                    {localStorage.getItem("is_headhunter") === "true" && user.user["pk"] !== single_ra.user["id"] && 
                      <button style={{color: "black"}} onClick={()=>fetchReCart( single_ra.id, single_ra.status, "추천제안", subitem.id, "DB1" )}>추천제안</button>}
                    
                    <button style={{color: "black"}} onClick={()=>fetchApplyStatus( single_ra.id, single_ra.status, "불합격", subitem.id, "DB1" )}>불합격</button>
                  </div>
                  // :null
                  , subitem, single_ra, json,"DB1")
                )
              })
            }

            let cart_second_data = [];
            if(single_ra.cart_second !== undefined){
              cart_second_data = single_ra.cart_second.map((subitem)=>{
                let newjson = json.filter(tempitem=> tempitem.userSecond !== null)
                console.log(newjson.filter(tempitem=>tempitem.userSecond.id === subitem.id)[0].user.id, user.user['pk'])
                return(
                  getDataFromList(info, 
                    newjson.filter(tempitem=>tempitem.userSecond.id === subitem.id)[0].user.id === user.user['pk']?
                    <div>
                      <button style={{color: "black"}}onClick={()=>fetchReCart( single_ra.id, single_ra.status, "추천", subitem.id, "DB2" )}>추천하기</button>
                      <button style={{color: "black"}}onClick={()=>fetchApplyStatus( single_ra.id, single_ra.status, "불합격", subitem.id, "DB2" )}>불합격</button>
                    </div>
                  :
                    <div>
                      <button style={{color: "black"}} onClick={()=>fetchReCart( single_ra.id, single_ra.status, "제안보냄", subitem.id, "DB2" )}>지원제안</button>
                      <button style={{color: "black"}} onClick={()=>fetchApplyStatus( single_ra.id, single_ra.status, "불합격", subitem.id, "DB2" )}>불합격</button>
                    </div>
                  , subitem, single_ra, json, "DB2")
                )
              })
            }

            let cart_sent_data = [];
            if(single_ra.cart_sent !== undefined){
              cart_sent_data = single_ra.cart_sent.map((subitem)=>{
                return(
                  getDataFromList(info, "답변대기중"
                  , subitem, single_ra, json, "DB1")
                )

              })
            }

            let cart_sent_second_data = [];
            if(single_ra.cart_sent_second !== undefined){
              cart_sent_second_data = single_ra.cart_sent_second.map((subitem)=>{
                return(
                  getDataFromList(info, "답변대기중"
                  , subitem, single_ra, json, "DB2")
                )

              })
            }

            let cart_accept_data = []
            if(single_ra.cart_accept !== undefined){
              cart_accept_data = single_ra.cart_accept.map((subitem)=>{
                return(
                  getDataFromList(info, 
                    user.user["pk"] === single_ra.user?
                  <div>
                    <button style={{color: "black"}}onClick={()=>fetchApplyStatus( single_ra.id, single_ra.status, "서류합격", subitem.id, "DB1" )}>서류합격</button>
                    <button style={{color: "black"}}onClick={()=>fetchApplyStatus( single_ra.id, single_ra.status, "불합격", subitem.id, "DB1" )}>불합격</button>
                  </div>
                  : 
                  <div>
                    <button style={{color: "black"}}onClick={()=>fetchReCart( single_ra.id, single_ra.status, "추천", subitem.id, "DB1" )}>추천하기</button>
                    <button style={{color: "black"}}onClick={()=>fetchApplyStatus( single_ra.id, single_ra.status, "불합격", subitem.id, "DB1" )}>불합격</button>
                  </div>
                  , subitem, single_ra, json, "DB1")
                )
              })
            }

            let cart_accept_second_data = []
            if(single_ra.cart_accept_second !== undefined){
              cart_accept_second_data = single_ra.cart_accept_second.map((subitem)=>{
                return(
                  getDataFromList(info, 
                    user.user["pk"] === single_ra.user?
                  <div>
                    <button style={{color: "black"}}onClick={()=>fetchApplyStatus( single_ra.id, single_ra.status, "서류합격", subitem.id, "DB2" )}>서류합격</button>
                    <button style={{color: "black"}}onClick={()=>fetchApplyStatus( single_ra.id, single_ra.status, "불합격", subitem.id, "DB2" )}>불합격</button>
                  </div>
                  : 
                  <div>
                    <button style={{color: "black"}}onClick={()=>fetchReCart( single_ra.id, single_ra.status, "추천", subitem.id, "DB2" )}>추천하기</button>
                    <button style={{color: "black"}}onClick={()=>fetchApplyStatus( single_ra.id, single_ra.status, "불합격", subitem.id, "DB2" )}>불합격</button>
                  </div>
                  , subitem, single_ra, json, "DB2")
                )
              })
            }

            let docu_data = []
            if(single_ra.docu !== undefined){
              docu_data = single_ra.docu.map((subitem)=>{
                return(
                  getDataFromList(info, user.user["pk"] === single_ra.user?
                  <div>
                    <button style={{color: "black"}}onClick={()=>fetchApplyStatus( single_ra.id, single_ra.status, "최종합격", subitem.id, "DB1" )}>최종합격</button>
                    <button style={{color: "black"}}onClick={()=>fetchApplyStatus( single_ra.id, single_ra.status, "불합격", subitem.id, "DB1" )}>불합격</button>
                  </div>:null
                  , subitem, single_ra, json, "DB1")
                )
              })
            }

            let docu_second_data = []
            if(single_ra.docu_second !== undefined){
              docu_second_data = single_ra.docu_second.map((subitem)=>{
                return(
                  getDataFromList(info, user.user["pk"] === single_ra.user?
                  <div>
                    <button style={{color: "black"}}onClick={()=>fetchApplyStatus( single_ra.id, single_ra.status, "최종합격", subitem.id, "DB2" )}>최종합격</button>
                    <button style={{color: "black"}}onClick={()=>fetchApplyStatus( single_ra.id, single_ra.status, "불합격", subitem.id, "DB2" )}>불합격</button>
                  </div>:null
                  , subitem, single_ra, json, "DB2")
                )
              })
            }

            let interview_data = []
            if(single_ra.interview !== undefined){
              interview_data = single_ra.interview.map((subitem)=>{
                let newobj = subitem;
                newobj.email = subitem.email
                newobj.position = single_ra.job
                
                newobj.path = json.filter((item)=> item.user ? item.user.email === subitem.email: item.userSecond.email === subitem.email)[0].recart || "후보자지원"

                newobj.status = json.filter((item)=> item.user ? item.user.email === subitem.email: item.userSecond.email === subitem.email)[0].step
                // newobj.created = json.length ? json.filter((item)=> item.user ? item.user.email === subitem.email: item.userSecond.email === subitem.email)[0].created.split('T')[0]: null
                newobj.updated = json.length ? json.filter((item)=> item.user ? item.user.email === subitem.email: item.userSecond.email === subitem.email)[0].updated.split('T')[0]: null
                return newobj
              })
            }


            let success_data = []
            if(single_ra.success !== undefined){
              success_data = single_ra.success.map((subitem, index)=>{
                return(
                  getDataFromList(info, "사례금보내기"
                  , subitem, single_ra, json, "DB1")
                )

              })
            }

            let success_second_data = []
            if(single_ra.success_second !== undefined){
              success_second_data = single_ra.success_second.map((subitem, index)=>{
                return(
                  getDataFromList(info, "사례금보내기"
                  , subitem, single_ra, json, "DB2")
                )

              })
            }

            
            let timeout_data = []
            if(single_ra.timeout !== undefined){
              timeout_data = single_ra.timeout.map((subitem)=>{

                return(
                  getDataFromList(info, null
                  , subitem, single_ra, json, "DB1")
                )
              })
            }

            let timeout_second_data = []
            if(single_ra.timeout_second !== undefined){
              timeout_second_data = single_ra.timeout_second.map((subitem)=>{

                return(
                  getDataFromList(info, null
                  , subitem, single_ra, json, "DB2")
                )
              })
            }

            let failed_data = []
            if(single_ra.failed !== undefined){
              failed_data = single_ra.failed.map((subitem)=>{
                
                return(
                  getDataFromList(info, null
                  , subitem, single_ra, json, "DB1")
                )
              })
            }

            let failed_second_data = []
            if(single_ra.failed_second !== undefined){
              failed_second_data = single_ra.failed_second.map((subitem)=>{
                
                return(
                  getDataFromList(info, null
                  , subitem, single_ra, json, "DB2")
                )
              })
            }

            // console.log(recommended_data, recommended_second_data)


            let final_data = []
            if(single_ra.applicant === undefined){
              final_data = [].concat.apply([], [  
                app_data, 
                cart_data, 
                cart_second_data,
                cart_sent_data,  
                cart_sent_second_data,
                cart_accept_data,
                cart_accept_second_data,
                docu_data, 
                docu_second_data,
                recommended_data, 
                recommended_second_data,
                recommended_sent_data,
                recommended_sent_second_data,
                recommended_accepted_data,
                recommended_accepted_second_data,
                success_data,
                success_second_data,
                timeout_data,
                timeout_second_data,
                failed_data,
                failed_second_data
              ])
            }
            else{
              final_data = [].concat.apply([], [
                app_data, 
                cart_data, 
                cart_second_data,
                cart_sent_data,  
                cart_sent_second_data,
                cart_accept_data,
                cart_accept_second_data,
                docu_data, 
                docu_second_data,
                recommended_data, 
                recommended_second_data,
                recommended_sent_data,
                recommended_sent_second_data,
                recommended_accepted_data,
                recommended_accepted_second_data,
                success_data,
                success_second_data,
                timeout_data,
                timeout_second_data,
                failed_data,
                failed_second_data  ])
            }
            // console.log("FINAL", final_data)
        
            
        
            setApplicants(final_data)    
        
            setSingle(single_ra)

            // // console.log(arr)
            // setStatus(arr)
          }
        }
        

        else {history.push('/recruiter/raboard/')}
      
        

      })
    }
  
  async function fetchUserData(){
    fetch(state.awslink + "/user/rauserinfo/?id=" + current_id + "&status=" + current_status, {
      method: 'GET',
      headers: header,
      })
      .then(response => response.json())
      .then(json=>{
        console.log(json)
        // // console.log(json["school"][0]["title"])
        setSchoolwork(json)
        fetchSingleApplicants(json)
      })
  }

  useEffect(()=>{
    fetchUserData()
  }, [state.singleRa, changed])
  

  function fetchStatus(e, tag, index){
    // console.log(e)
    // // console.log(filtered_status)
    // console.log(status)
    // console.log(status.filter((item)=>item.item===tag))

    if(window.confirm(e.value + "?")){
      // console.log("ok")
      // setStatus(e)
      // window.location.reload()
      history.push('/recruiter/raboard/' + currentId)
    }
    else{
      // console.log("cancle")
      // // console.log(status.filter((item)=>item.item===tag && item.email==="mashi79513@yonsei.ac.kr"))
      // // console.log(status.filter((item)=>item.item===tag)[0].value)
      // setStatus(status)
      // window.location.reload()
    }
    
  }

  
  return(
    <>
    {/* {// console.log("RENDER")} */}
    {state.width < state.breakpoint ? 
      null
    :
      <Wrapper>
        <MidWrapper>
        
          <RightWrapper>
          {/* {changed} */}
            {applicants?    
            <>

              <TableApp

                data = {applicants}
                columns = {columnsAtt}
                currentId = {current_id}
                currentStatus = {current_status}
              />

            </>
            : null}

          </RightWrapper>
        </MidWrapper>
      </Wrapper>   
      }
    </>
  )
}


const Wrapper = styled.div`
  display: flex;
  position: absolute;
  
  width: 100vw;
  height: calc(100vh - 45px);

  /* margin-top: 45px; */

  justify-content: center;
  align-items: center;

  /* border: green solid; */
  z-index: 1;
  background-color: transparent;
`

const MidWrapper = styled.div`
  display: flex;
  width: 90%;
  max-width: 1060px;
  height: 100%;
  justify-content: center;
  align-items: flex-end;

  background-color: transparent;
  /* border: red solid; */
  /* border-radius: 5px; */
  z-index: 1;

  flex-direction: row;
`
const RightWrapper = styled.div`
    display: flex;
    /* min-width: 69%; */
    min-width: 700px;
    max-width: 69%;
    
    margin-left: 31%;

    min-height: 100%;
    position: relative;
    margin-top: 20px;
    /* top: calc((100vh - 45px) * 0.05); */
    height: auto;
    /* border: red solid; */
    background-color: transparent;

    align-items: flex-start;
    justify-content: flex-start;
    flex-direction: column;

    z-index: 3;

    box-sizing: border-box;
    /* padding: 20px; */
    border-radius: 5px;
    /* border: .5px solid rgba(0,0,0,0.4); */

    position:relative;

    /* > span{
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      flex-direction: column;
      margin-bottom: 30px;
      > div{
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        
      }
    } */
`

export default ComRaboardDetail